import { Injectable } from '@angular/core';

import { Http, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { BrowserStorageService } from './storage.service';


@Injectable()
export class WebService {

  displayName = null;

  constructor(private http: Http, private storage:BrowserStorageService) {
  }

  createAuthorizationHeader(headers: Headers) {
    let token = this.storage.get('auth_token');    
    if (token) {
      headers.append('x-auth-token', token); 
    }
  }

  get(url:string) {
    let headers = new Headers();
    this.createAuthorizationHeader(headers);
    return this.http.get(url, {"headers": headers}).map(res => {
        console.log(res);
        return res.json();
    });
  }

  getNoAuth(url:string) {
    return this.http.get(url).map(res => res.json());
  }

  upload(url:string, data) {
    let formData:FormData = new FormData();
    formData.append('file', data);
    let headers = new Headers();
    this.createAuthorizationHeader(headers);
    return this.http.post(url, formData, {"headers": headers}).map(res => {
        console.log(res);
        return res.json();
    });
  }

  post(url:string, data) {
    let headers = new Headers();
    this.createAuthorizationHeader(headers);
    return this.http.post(url, data, {"headers": headers}).map(res => {
        console.log(res);
        return res.json();
    });
  }
  
  put(url:string, data) {
    let headers = new Headers();
    this.createAuthorizationHeader(headers);
    return this.http.put(url, data, {"headers": headers}).map(res => {
        console.log(res);
        return res['_body'] ? res.json() : null;
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/web.service.ts